import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Directus from '../../helpers/directusLink';

const AboutValues = ({ t, values }) => {
    const list = useMemo(() => values.map((el, i) => (
        <div key={ i } className={ `about-value about-value-${ i + 1 }` } style={ { top: el.x, left: el.y } }>
            <div className="about-values-icon">
                <img src={ Directus.getLinkImage(el.icon) } alt={ el.name }/>
            </div>
            <h3>{ el.name }</h3>
            <div
              dangerouslySetInnerHTML={ { __html: el.description } }
            />
        </div>)), [values]);

    return (
        <div className="about-values">
            <div className="about-values-content">
                {list[0]}
                {list[1]}
                <div className="about-values-circle1">
                    <div className="about-values-circle2">
                        <div className="about-values-circle3">
                            <h3>{ t('about.values.title') }</h3>
                        </div>
                    </div>
                </div>
                {list[2]}
                {list[3]}
            </div>
        </div>
    );
};

AboutValues.propTypes = {
    t: PropTypes.func.isRequired,
    values: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
    })).isRequired
};


export default AboutValues;



// WEBPACK FOOTER //
// ./src/components/content/about/AboutValues.jsx